import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// 获取门店列表
export function getStoreList (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/get_store`, { params: { ...query, axiosType: 'python' } })
}

// 获取房间类型
export function getRoomType (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/get_room_map`, { params: { ...query, axiosType: 'python' } })
}

// 获取员工列表
export function getStaffList (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/get_staff`, { params: { ...query, axiosType: 'python' } })
}
// 获取全局完成率
export function getDBSummary (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/summary`, { params: { ...query, axiosType: 'python' } })
}

// test mysql connection
export function testMysqlConnection () {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/get_staff`, { params: { axiosType: 'python' } })
}

// ----------------- 以下是新的接口 -----------------

// 获取产康汇总数据
export function getProductSummary (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/postpartum_total`, { params: { ...query, axiosType: 'python' } })
}

// 获取到家汇总数据
export function getHomeServiceSummary (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/home_service_total`, { params: { ...query, axiosType: 'python' } })
}

// 获取到家月度列表
export function getHomeServiceMonthlyList (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/month_home_service`, { params: { ...query, axiosType: 'python' } })
}

// 获取套餐汇总
export function getPackageSummary (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/signed_order`, { params: { ...query, axiosType: 'python' } })
}

// 获取套餐月度列表
export function getPackageMonthlyList (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/month_package`, { params: { ...query, axiosType: 'python' } })
}

// 获取客户满意度
export function getCustomerSatisfaction (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/satisfaction`, { params: { ...query, axiosType: 'python' } })
}

// 获取门店房间状态
export function getStoreRoomStatus (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/room_statistics`, { params: { ...query, axiosType: 'python' } })
}

// 获取日服务完成率汇总
export function getServiceCompletionRateSummary (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/dashboard/daily_completion_rates`, { params: { ...query, axiosType: 'python' } })
}
